import { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { Link } from "react-router-dom";
import { getAllAdHocSurveysAsync } from "../../Helpers/API/AdHocSurveyApi";
import AdHocSurveyTableRow from "./AdHocSurveyTableRow";

const AdHocSurveyList = () => {
	const [adHocSurveys, setAdHocSurveys] = useState([]);

	useEffect(() => {
		async function getAdHocSurveys() {
			const data = await getAllAdHocSurveysAsync();
			setAdHocSurveys(data);
		}
		getAdHocSurveys();
	}, []);

	const deleteRow = (id) => {
		const rows = [...adHocSurveys];
		setAdHocSurveys(rows.filter((adHocSurvey) => adHocSurvey.id !== id));
	};

	const AdHocSurveysTable = () =>
		adHocSurveys.map((adHocSurvey) => <AdHocSurveyTableRow adHocSurvey={adHocSurvey} key={adHocSurvey.id} deleteRow={deleteRow} />);

	return (
		<div>
			<div className="breadcrumbs">
				<Breadcrumb>
					<Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
						Home
					</Breadcrumb.Item>
					<Breadcrumb.Item active>Ad-hoc Surveys</Breadcrumb.Item>
				</Breadcrumb>
			</div>
			<h4>Ad-hoc Surveys</h4>
			<div className="table-wrapper">
				<Link to="/adhoc-surveys/create-adhoc-survey/" className="header-link btn">
					Create a new ad-hoc survey
				</Link>
				<Table striped bordered hover>
					<thead>
						<tr>
							<th>Name</th>
							<th className="d-none d-sm-table-cell">Alchemer ID</th>
							<th className="d-none d-sm-table-cell">Mandrill Template</th>
							<th className="grid-actions-header-large">&nbsp;</th>
						</tr>
					</thead>
					<tbody>{AdHocSurveysTable()}</tbody>
				</Table>
			</div>
		</div>
	);
};

export default AdHocSurveyList;
